import { Injectable } from '@angular/core';
import { IStation } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class MathService {
  private readonly DISTANCE_MAX = 1;
  private readonly DISTANCE_MAX_LARGE = 2;

  public stationIsClose(
    p1: google.maps.LatLng,
    p2: google.maps.LatLng,
    pStation: google.maps.LatLng
  ): boolean {
    const d1 = this.getDistanceBetweenPoints(p1, pStation);
    if (d1 <= this.DISTANCE_MAX) {
      return true;
    }
    const d2 = this.getDistanceBetweenPoints(p2, pStation);
    if (d2 <= this.DISTANCE_MAX) {
      return true;
    }
    const dLine = this.getDistanceBetweenPoints(p1, p2);
    if (dLine > d1 && dLine > d2) {
      const distance = this._getDistanceWithFormula(d1, d2, dLine);
      const maxDistance =
        dLine >= 5 ? this.DISTANCE_MAX_LARGE : this.DISTANCE_MAX;
      const isNear = isNaN(distance) || distance <= maxDistance;
      return isNear;
    }
    return false;
  }
  private _getDistanceWithFormula(d1: number, d2: number, d3: number): number {
    const middlePerimeter = (d1 + d2 + d3) / 2;
    return (
      (2 *
        Math.sqrt(
          middlePerimeter *
            (middlePerimeter - d1) *
            (middlePerimeter - d2) *
            (middlePerimeter - d3)
        )) /
      d3
    );
  }
  public getDistanceBetweenPoints(p1: any, p2: any): number {
    return Math.round(
      google.maps.geometry.spherical.computeDistanceBetween(p1, p2)
    )/1000;
  }
}
